import React, { useState } from 'react'
import CustomDrawer from '../CommonUi/CustomDrawer';
import CreateTaskForm from './CreateTaskForm';

function CreateTask({record}) {
	
  // Drawer state
  const [open, setOpen] = useState(false);
	return (

		<CustomDrawer
			permission={"update-product"}
			update
			title={"Update Slot"}
			width={33}
			open={open}
			setOpen={setOpen}
		>
			<CreateTaskForm editData={record} onClose={() => setOpen(false)} />
		</CustomDrawer>
	)
}

export default CreateTask
